import axios from 'axios';
import Cookies from 'universal-cookie';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getToken() {
    const cookies = new Cookies();
    const token = cookies.get("token");
    
    // Basic XSS protection
    if (token && (token.includes('<script') || token.includes('javascript:'))) {
        console.warn('Suspicious token content detected, removing token');
        return null;
    }
    
    return token;
}

/**
 * Get transcription with emotion probabilities for an AnalysisParent
 */
export const getTranscriptionWithEmotions = async (analysisParentUuid) => {
    try {
        const response = await axios.get(
            `${API_BASE}/analysis-parent/${analysisParentUuid}/transcription-with-emotions`,
            {
                headers: {
                    authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error getting transcription with emotions:', error);
        throw error;
    }
};

/**
 * Get basic transcription without emotions (for backward compatibility)
 */
export const getBasicTranscription = async (analysisParentUuid) => {
    try {
        const response = await axios.get(
            `${API_BASE}/analysis-parent/${analysisParentUuid}/transcription`,
            {
                headers: {
                    authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error getting basic transcription:', error);
        throw error;
    }
};

/**
 * Get emotion analysis summary for an AnalysisParent
 */
export const getEmotionAnalysisSummary = async (analysisParentUuid) => {
    try {
        const response = await axios.get(
            `${API_BASE}/analysis-parent/${analysisParentUuid}/emotion-summary`,
            {
                headers: {
                    authorization: `Bearer ${getToken()}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error getting emotion analysis summary:', error);
        throw error;
    }
};

/**
 * Update transcription for an AnalysisParent
 */
export const updateTranscription = async (analysisParentUuid, transcriptionResult) => {
    const token = getToken();
    const url = `${API_BASE}/analysis-parent/${analysisParentUuid}/transcription`;
    
    try {
        const response = await axios.put(
            url,
            {
                result: transcriptionResult
            },
            {
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating transcription:', error);
        throw error;
    }
};

/**
 * Check if enhanced transcription with emotions is available for an AnalysisParent
 */
export const checkEmotionDataAvailable = async (analysisParentUuid) => {
    try {
        const summary = await getEmotionAnalysisSummary(analysisParentUuid);
        
        return {
            hasAudioEmotions: summary.emotion_summary?.audio_emotion?.completed || false,
            hasVideoEmotions: summary.emotion_summary?.video_emotion?.completed || false,
            hasAnyEmotions: 
                (summary.emotion_summary?.audio_emotion?.completed || false) ||
                (summary.emotion_summary?.video_emotion?.completed || false)
        };
    } catch (error) {
        console.error('Error checking emotion data availability:', error);
        return {
            hasAudioEmotions: false,
            hasVideoEmotions: false,
            hasAnyEmotions: false
        };
    }
};